import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { moveAvatar, setAvatarInstructions, setAvatarPostAudioCallbackName, setAnimateAlex } from './avatarActions';

const getDisplayName = (WrappedComponent) => WrappedComponent.displayName || WrappedComponent.name || 'Component';

export default (mapStateToProps) => (WrappedComponent) => {
    class WithAvatarView extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                isAvatarInitialized: false,
            };
        }

        componentDidMount() {
            this.props.initialize(this.props)
                .then(() => {
                    this.setState({
                        isAvatarInitialized: true,
                    });
                });
        }

        componentDidUpdate(prevProps) {
            if (this.props.instructions !== prevProps.instructions) {
                this.props.initialize(this.props);
            }
        }

        render() {
            // filter out props specific to WithAvatarView
            const {
                position, instructions, initialize, postAudioCallback,
                ...componentProps
            } = this.props;
            return (
                <WrappedComponent
                    isAvatarInitialized={this.state.isAvatarInitialized}
                    {...componentProps} />
            );
        }
    }

    WithAvatarView.propTypes = {
        position: PropTypes.string.isRequired,
        instructions: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string),
        ]),
        postAudioCallback: PropTypes.string,
        initialize: PropTypes.func.isRequired,
        animateAlex: PropTypes.bool,
    };
    WithAvatarView.defaultProps = {
        instructions: undefined,
        postAudioCallback: undefined,
        animateAlex: false,
    };
    WithAvatarView.displayName = `WithAvatar(${getDisplayName(WrappedComponent)})`;

    const mapDispatchToProps = (dispatch) => ({
        initialize: ({ position, instructions, postAudioCallback, animateAlex }) => {
            if (instructions) {
                dispatch(setAvatarInstructions(instructions));
            }
            if (postAudioCallback) {
                dispatch(setAvatarPostAudioCallbackName(postAudioCallback));
            }
            dispatch(setAnimateAlex(animateAlex));
            return dispatch(moveAvatar(position));
        },
    });

    const WithAvatarContainer = connect(
        mapStateToProps,
        mapDispatchToProps,
    )(WithAvatarView);

    return WithAvatarContainer;
};
